import { Box, TextField, useMediaQuery } from "@mui/material";
import React from "react";

interface LegInputsProps {
  matchId: number;
  type: "home" | "away";
  values: string[];
  onChange: (idx: number, value: string) => void;
  onBlur: (idx: number) => void;
  tabIndexBase: number;
  idPrefix: string;
  inputHeight: number;
  isAdmin: boolean;
}

const LegInputs: React.FC<LegInputsProps> = ({
  matchId,
  type,
  values,
  onChange,
  onBlur,
  tabIndexBase,
  idPrefix,
  inputHeight,
  isAdmin,
}) => {
  //   const inputHeight = type === "home" || type === "away" ? 40 : 80;
  const isMobile = useMediaQuery("(max-width:600px)");

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        height: inputHeight,
        gap: 0,
        padding: 0,
        margin: 0,
        flex: 1,
      }}
    >
      {[0, 1, 2].map((i) => (
        <TextField
          key={i}
          id={`${idPrefix}_${i + 1}_${type}_${matchId}`}
          type="number"
          value={values[i]}
          disabled={!isAdmin}
          onChange={(e) => onChange(i, e.target.value)}
          onBlur={() => onBlur(i)}
          inputProps={{
            inputMode: "numeric",
            pattern: "[0-9]*",
            style: {
              textAlign: "center",
              fontSize: isMobile ? 12 : 18,
              padding: 0,
              margin: 0,
              height: inputHeight,
              minHeight: 0,
              boxSizing: "border-box",
              MozAppearance: "textfield",
              appearance: "textfield",
            },
            tabIndex: tabIndexBase + i,
            onWheel: (e: any) => e.currentTarget.blur(),
            onFocus: (e: any) => e.target.select(),
          }}
          sx={{
            flex: 1,
            width: "100%",
            height: inputHeight,
            minHeight: 0,
            minWidth: 0,
            margin: 0,
            padding: 0,
            "& .MuiOutlinedInput-root": {
              height: inputHeight,
              borderRadius: 0,
              "& fieldset": {
                border: "1px solid #ccc",
                borderRadius: 0,
              },
              "&:hover fieldset": {
                border: "1px solid #ccc",
              },
              "&.Mui-focused fieldset": {
                border: "1px solid #ccc",
                borderWidth: "1px",
              },
              "& input": {
                padding: 0,
                height: "100%",
                boxSizing: "border-box",
                "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
                  WebkitAppearance: "none",
                  margin: 0,
                },
                "&[type=number]": {
                  MozAppearance: "textfield",
                },
              },
            },
            "& .MuiInputLabel-root": {
              display: "none",
            },
          }}
        />
      ))}
    </Box>
  );
};

export default LegInputs;
